realProductType